"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return {
    autoCompleteWrapper: {
      padding: "0",
      "& > div:before": {
        display: "none"
      },
      "& > div:after": {
        display: "none"
      },
      transition: theme.transitions.create("opacity")
    },
    autoCompleteLabel: {
      transform: "scale(0.75)",
      cursor: "pointer",
      fontWeight: "bold",
      marginBottom: "2px",
      "&[class]": {
        color: theme.palette.primary.main
      }
    },
    clearButton: {
      marginRight: theme.spacing(1)
    },
    disabled: {
      opacity: "50%"
    },
    dropdownInputWrapper: {
      padding: "0",
      "&.prmbl-autocomplete__control": {
        minHeight: "56px",
        border: "none",
        borderRadius: "2px",
        boxShadow: "none",
        cursor: "text",
        backgroundColor: "transparent",
        boxSizing: "border-box"
      },
      "&.prmbl-autocomplete__control:hover": {
        border: "none"
      },
      "&.prmbl-autocomplete__value-container": {
        padding: theme.spacing(1.5)
      },
      "&.prmbl-autocomplete__input > input": {
        textAlign: "inherit",
        height: "auto",
        lineHeight: "inherit"
      },
      "&.prmbl-autocomplete__multi-value": {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        lineHeight: "1.75"
      },
      "&.prmbl-autocomplete__multi-value__label": {
        color: theme.palette.primary.contrastText,
        padding: "3px 3px 3px 6px"
      },
      "&.prmbl-autocomplete__multi-value__remove": {
        paddingLeft: theme.spacing(0.5),
        paddingRight: theme.spacing(0.5),
        cursor: "pointer",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
          color: theme.palette.primary.contrastText
        }
      },
      "&.prmbl-autocomplete__option": {
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        cursor: "pointer",
        padding: theme.spacing(2)
      },
      "&.prmbl-autocomplete__option:active": {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
      },
      "&.prmbl-autocomplete__option--is-focused": {
        background: theme.palette.grey[300],
        color: theme.palette.getContrastText(theme.palette.grey[300])
      },
      "&.prmbl-autocomplete__option--is-selected": {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
      },
      "&.prmbl-autocomplete__dropdown-indicator": {
        cursor: "pointer",
        height: "100%",
        alignItems: "center",
        color: theme.palette.grey[400]
      },
      "&.prmbl-autocomplete__dropdown-indicator:hover": {
        color: theme.palette.grey[500]
      },
      "&.prmbl-autocomplete__control--is-focused .prmbl-autocomplete__dropdown-indicator": {
        color: theme.palette.grey[600]
      },
      "&.prmbl-autocomplete__clear-indicator": {
        cursor: "pointer"
      },
      "&.prmbl-autocomplete__indicator": {
        padding: theme.spacing(1)
      },
      "&.prmbl-autocomplete__container": {
        padding: "0px !important"
      },
      "&.prmbl-autocomplete__menu": {
        background: theme.palette.background.paper,
        margin: "0 1px",
        borderRadius: "0 0 2px 2px",
        width: "calc(100% - 2px)",
        borderTop: "0",
        zIndex: "5",
        boxSizing: "border-box"
      },
      "&.prmbl-autocomplete__menu-list": _objectSpread({
        padding: "0"
      }, theme.scrollbars.main),
      "&.prmbl-autocomplete__placeholder": {
        color: theme.palette.text.secondary
      },
      "&.prmbl-autocomplete__group-heading": {
        padding: theme.spacing(1, 2),
        background: theme.palette.background.paper,
        position: "sticky",
        top: 0,
        color: theme.palette.text.secondary,
        fontWeight: theme.typography.fontWeightBold
      },
      "&.prmbl-autocomplete__single-value": {
        color: theme.palette.text.primary
      },
      "&.prmbl-autocomplete__menu-notice": {
        padding: theme.spacing(1, 1.5)
      }
    },
    dropdownInputWrapperCompact: {
      "&.prmbl-autocomplete__control": {
        minHeight: "37px"
      },
      "&.prmbl-autocomplete__value-container": {
        padding: "2px 6px"
      },
      "&.prmbl-autocomplete__indicator": {
        padding: "0"
      }
    },
    dropdownInputWrapperInline: {
      "&.prmbl-autocomplete__input > input": {
        position: "absolute",
        left: theme.spacing(1.5),
        top: "50%",
        transform: "translateY(-50%)"
      },
      "&.prmbl-autocomplete__single-value": {
        margin: 0
      }
    },
    portalElement: {
      zIndex: theme.zIndex.modal + 1,
      position: "relative"
    },
    readOnly: {
      "& .prmbl-autocomplete__indicators": {
        display: "none"
      },
      "& .prmbl-autocomplete__multi-value__remove": {
        display: "none"
      },
      "& .prmbl-autocomplete__multi-value__label": {
        paddingRight: "6px"
      }
    }
  };
};

exports.styles = styles;